const pubNubTimetokenToTimestamp = (pubNubTimeToken: string) =>
  parseInt(pubNubTimeToken.substring(0, pubNubTimeToken.length - 4));

export default pubNubTimetokenToTimestamp;
